<template>
  <div class="main" @x-keyup.tab="toggleInterface()">
    <Map class="map-object" ref="map" @select="openEtablissement()"/>

    <div class="top-block" v-if="displayInterface">
			<TitleControl class="title-control" v-if="!searching"/>
			<SearchControl class="search-control" :class="{searching: searching}" @search="searching=!!$event.length"/>
    </div>


    <div class="bottom-block" v-if="displayInterface">

      <div class="secondary-bottom-block">
        <GradientControl class="gradient-control" :gradient="villeData.gradient"/>
        <div class="floating-buttons-control">
          <MenuButtonControl class="menu-btn-control" @close="closeInfo()" @open="openInfo()"/>
          <ZoomControl class="zoom-control" @zoom="zoomCommand($event)"/>
					<FullscreenControl class="fullscreen-control" v-if="isEmbedded"/>
        </div>
      </div>

      <!-- CtaControl class="cta-control"/ -->
      <InfoControl class="info-control" :class="{open: infoOpen}"  @close="closeInfo()"/>
      <EtablissementControl class="etablissement-control" :class="etablissementClass" @close="closeEtablissement()" @full="fullOpenEtablissement()" @half="halfOpenEtablissement()" @home="goHome()"/>
    </div>



  </div>
</template>

<script>
import Map from '@/components/Map.vue'
import SearchControl from '@/components/SearchControl.vue'
import InfoControl from '@/components/InfoControl.vue'
//import CtaControl from '@/components/CtaControl.vue'
import ZoomControl from '@/components/ZoomControl.vue'
import MenuButtonControl from '@/components/MenuButtonControl.vue'
import EtablissementControl from '@/components/EtablissementControl.vue'
import GradientControl from '@/components/GradientControl.vue'
import TitleControl from '@/components/TitleControl.vue'
import FullscreenControl from '@/components/FullscreenControl.vue'

//import AttributionControl from '@/components/AttributionControl.vue'
import villeData from "@ville/data";


export default {
	name: 'Main',
	components: {
		Map,
		SearchControl,
		InfoControl,

		//CtaControl,
		ZoomControl,
		MenuButtonControl,
		EtablissementControl,
		GradientControl,
		//AttributionControl,
		TitleControl,
		FullscreenControl,
	},
	data() {
		return {
			isEmbedded: false,
			displayInterface: true,
			searching: false,
			infoOpen: false,
			etablissementOpen: 'close',
			villeData: villeData,
		}
	},
  created() {
		if (location.search.match(/embed=1/)) {
			this.isEmbedded = true;
		}

		this.$store.watch(
			(state) => this.$store.getters.etablissement,
			(e) => {
				if (e.slug) {
					this.openEtablissement()
				}
				else {
					this.closeEtablissement()
				}
			}
		);
	},
	computed: {
		etablissementClass() {
			return 'etablissement-' + this.etablissementOpen
		}
	},
	methods: {
		// TODO: suppr en prod
		goHome() {
			this.$router.push('/')
			this.$refs.map.fitScreen()
		},
		toggleInterface() {
			this.displayInterface = !this.displayInterface
		},

		openInfo() {
			this.infoOpen = true
		},
		closeInfo() {
			this.infoOpen = false
		},

		openEtablissement() {
			let width = window.innerWidth;
			let height = window.innerHeight;

			if (height > 600 && width > 600) {
				this.etablissementOpen = 'full'
			}
			else {
				this.etablissementOpen = 'open'
			}
		},
		fullOpenEtablissement() {
			this.etablissementOpen = 'full'
		},
		closeEtablissement() {
			this.$router.push('/')
			this.etablissementOpen = 'close'
		},
		halfOpenEtablissement() {
			this.etablissementOpen = 'open'
		},
		zoomCommand(action) {
			this.$refs.map.zoomCommand(action);
		}
	}
}
</script>

<style lang="scss">
@import "bulma/sass/utilities/_all.sass";
@import "bulma/sass/base/_all.sass";
@import "bulma/sass/elements/button.sass";
@import "bulma/sass/elements/container.sass";
@import "bulma/sass/elements/form.sass";
@import "bulma/sass/elements/icon.sass";
@import "bulma/sass/elements/title.sass";
//@import "bulma/bulma.sass";


.map-object {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index:100;
}

.bottom-block {

  pointer-events: none;
  position: absolute;

  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  flex-direction: column;

}


.top-block {

  pointer-events: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;

  display: flex;
  flex-direction: column;
  align-items: center;

}



.secondary-bottom-block {
  width: 100%;
  display: flex;
  pointer-events: none;
  justify-content: space-between;
  align-items: end;
  padding: 0 12px;
  margin-bottom: 2rem;

	@include from(420px) {
		margin-bottom: 1rem;
	}

  @include from($tablet) {

    position: absolute;
    bottom: 1rem;
    left: 0;
  }
}

.gradient-control {
	z-index: 800;
}

.zoom-control {
  display: none;
}

.floating-buttons-control {
	z-index: 1045;
	display: flex;
	flex-direction: column-reverse;
	align-items: center;

  @include from($tablet) {
		flex-direction: column;
    position: fixed;
    top: 1rem;
    right: 1rem;
		/*z-index:1100;*/

    .zoom-control {
      display: flex;
    }
  }
}

.info-control {
  z-index: 1200;
  position: absolute;
  left: 0;
  bottom: 0;
	right: 0;

  max-height: 100vh;
	transform: translateY(100%);
  transition: transform 1s;
  padding: 1rem 1rem 0;
	overflow-x: hidden;
	overflow-y: auto;

  &.open {
    transform: translateY(0);
    transition: transform 1s;
  }
}

.cta-control {
  z-index: 1100;

}

.title-control {
	z-index: 1000;
	margin-bottom: 0 !important;
}

.search-control {
	z-index: 1000;

	&.searching {
		//z-index: 1200;
		margin-top: 1rem;
	}
}

.menu-btn-control {
//	margin: 4px 0 !important;
}

.etablissement-control {
	z-index: 1050;
	position: absolute;
	left: 0;
	bottom: 0;
	right: 0;
	overflow-x: hidden;
	overflow-y: auto;
	transform: translateY(100%);
	transition: transform 1s;

	max-height: 100vh;
	@include from($tablet) {
		max-height: 49.5vh;
	}


	&.etablissement-open,
	&.etablissement-full {
		transform: translateY(0);
		transition: transform 1s;
	}
}
</style>


